import VideoContainer from '../../Shared/VideoContainer';
import { acceptVideoRequest } from '../../../actions';
import SurveyContainer from '../SurveyContainer';
import colors from '../../colors';
import WarningButton from '../../Shared/WarningButton';
import * as React from 'react';
import styled, { keyframes, StyledFunction } from 'styled-components';
import { Message } from '../../../typedefs/store';
import { subtleScrollbarStyles, styledWithProps } from '../../../util/styles';
import IconBar from './IconBar';
import Minimized from '../../Shared/Minimized';
import MessageListContainer from '../../Shared/MessageListContainer';
import FullOverlay from '../../Shared/FullOverlay';
import BannerContainer from '../../Shared/BannerContainer';
import PresenceMessage from '../../Shared/PresenceMessage';
import Links from '../../Shared/Links';
import Spinner from '../../Shared/Spinner';
import SendForm from './SendForm';
import Base, { BaseProps, BaseState } from '../BaseConversationWrapper';
import * as AlertIcon from 'react-icons/lib/io/alert-circled';
import { WindowWrapper, Flex, AvatarWrapper, TranscriptWrapper } from './Styles';

export default class Proactive extends Base<BaseProps, BaseState> {
    public render() {
        if (this.props.isMinimized) {
            return <Minimized numUnread={this.props.numUnread} onClick={this.onMinimize} />;
        }

        return (
            <WindowWrapper>
                {!this.props.showEndDialog && (
                    <IconBar onMinimize={this.onMinimize} onClose={this.onClose} />
                )}
                <Flex>
                    <AvatarWrapper>
                        <img src={this.props.convoAvatar} />
                    </AvatarWrapper>
                    <TranscriptWrapper>
                        <VideoContainer wrapperComponent={VideoWrapper} />
                        <BannerContainer style={{ margin: '-15px -15px 15px -15px' }} />
                        <Body
                            innerRef={(c: HTMLDivElement) => (this.bodyRef = c)}
                            ended={this.props.ended}
                        >
                            {this.props.showEndDialog && this.renderEndPending()}
                            {this.props.ending && this.renderEnding()}
                            <MessageListContainer
                                send={this.handleSend}
                                scrollToBottom={this.scrollToBottom}
                            />
                        </Body>
                        {this.props.ended ? (
                            <div>
                                {!this.props.surveyCompleted ? (
                                    <SurveyContainer />
                                ) : (
                                    <Links links={this.props.links} />
                                )}
                            </div>
                        ) : (
                            <SendForm
                                send={this.handleSend}
                                changeTypingStatus={this.props.changeTypingStatus}
                                disabled={this.props.disableSending}
                            />
                        )}
                    </TranscriptWrapper>
                </Flex>
            </WindowWrapper>
        );
    }

    private renderEndPending() {
        return (
            <FullOverlay>
                <div style={{ maxWidth: '100%' }}>
                    Are you sure you want to end this conversation?
                </div>
                <ButtonWrapper>
                    <WarningButton onClick={this.onClose}>Cancel</WarningButton>
                    <WarningButton primary={true} onClick={this.endConvo}>
                        <AlertIcon style={{ marginRight: 5 }} /> End
                    </WarningButton>
                </ButtonWrapper>
            </FullOverlay>
        );
    }

    private renderEnding() {
        return (
            <FullOverlay>
                <Spinner size={32} />
            </FullOverlay>
        );
    }
}

const Body = styledWithProps<{ ended: boolean }>(styled.div)`
    ${subtleScrollbarStyles} overflow-x: hidden;
    overflow-y: auto;
    padding-right: 7px;
    margin-right: -7px;
    max-height: ${props => (props.ended ? '40vh' : '50vh')};
`;

const ButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1em;
    & button {
        margin-right: 5px;
        &:last-child {
            margin-right: 0;
        }
    }
`;

const VideoWrapper = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10;
    background-color: #242424;
    top: 0;
    left: 0;
    height: 244px;
    width: 100%;
    color: white;
    box-shadow: 0px 9px 14px -8px rgba(0, 0, 0, 0.75);
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Conversation/Proactive/ProactiveWrapper.tsx